import { render, staticRenderFns } from "./NewCategory.vue?vue&type=template&id=20fcf3a2&scoped=true&"
import script from "./NewCategory.vue?vue&type=script&lang=js&"
export * from "./NewCategory.vue?vue&type=script&lang=js&"
import style0 from "./NewCategory.vue?vue&type=style&index=0&id=20fcf3a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fcf3a2",
  null
  
)

export default component.exports